module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"editAddress":{"partOne":"Doesn\u0027t look right?","partTwo":"update your details"},"prompt":"I don\u0027t have a broadband supplier","select":"Please select","yourAddress":"Your address"}}')
  delete Component.options._Ctor
}
